<template>
  <div>
    <svg
      v-if="active"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.77969 14.7052L4.28072 14.7052C3.87564 16.3331 3.39423 19.9316 6.88182 19.9316L15.9883 19.9316C13.4883 19.9316 12.4377 17.1167 13.3797 14.7052L5.77969 14.7052Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.807 19.932C22.1474 19.932 14.3584 5.71688 19.9999 4H9.92758C6.28585 5.15659 8.15765 13.3254 8.5424 14.6967"
        stroke="currentColor"
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M11.7939 7.82373L14.2574 7.82373"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.7939 11.2681L14.2574 11.2681"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-else
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.77969 14.7053L4.28072 14.7053C3.87564 16.3332 3.39423 19.9318 6.88182 19.9318L15.9883 19.9318C13.4883 19.9318 12.4377 17.1168 13.3797 14.7053L5.77969 14.7053Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.807 19.932C22.1474 19.932 14.3584 5.71688 19.9999 4H9.92758C6.28585 5.15659 8.15765 13.3254 8.5424 14.6967"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M11.7939 7.82361L14.2574 7.82361"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.7939 11.2683L14.2574 11.2683"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean,
  },
}
</script>

<style>

</style>
